module.exports = "/_next/static/images/adb4a4b15b78c73c5ca1a278dc6ed6b8-features-meal-sm.jpg";